import React from 'react'
import CustomerManagerTableHead from "./CustomerManagerTableHead"
import CustomerManagerTableBody from "./CustomerManagerTableBody"
import {Spin} from "antd"

function CustomerManagerTable(props) {
    const {loading, error, detailListCustomers, selectAll, onCheckALl, arrSelected, onSelected} = props

    return <div className="LeadTable">
        <Spin spinning={loading} tip="Đang lấy dữ liệu...">
            <table className="table">
                <CustomerManagerTableHead
                    selectAll={selectAll}
                    onCheckALl={onCheckALl}
                    arrSelected={arrSelected}
                />
                <CustomerManagerTableBody
                    loading={loading}
                    error={error}
                    detailListCustomers={detailListCustomers}
                    arrSelected={arrSelected}
                    onSelected={onSelected}
                />
            </table>
        </Spin>
    </div>
}

export default CustomerManagerTable
